import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { IndexedCollection } from '../../../shared/types'
import { indexCollection } from '../../../shared/utils'
import { DrrHttpClient } from '../../../http/drr-http-client';
import { AARData, EvStationDetailsResponse, TowDestinationResponse } from './aar.types';
import { EvStationResponseSchema } from './aar.model';
import { AARDataAdapter } from '../../../shared/adapters/AARDataAdapter';

const RADIUS_EV_STATIONS = 10

@Injectable({
  providedIn: 'root',
})
export class EvStationService {

  constructor(
    private httpClient: DrrHttpClient,
    private aarDataAdapter: AARDataAdapter,
  ) {
  }

  search$(latitude, longitude, limit?, radius = RADIUS_EV_STATIONS): Observable<IndexedCollection<AARData>> {
    return this.httpClient
      .get<TowDestinationResponse<EvStationDetailsResponse>>('/bff/tow-destinations/ev-stations', {
        params: {
          latitude: String(latitude),
          longitude: String(longitude),
          radius: String(radius),
          ...(limit ? { limit: String(limit) } : {}),
        },
      })
      .pipe(
        tap((response) => EvStationResponseSchema.validateSync(response)),
        map((response) => {
          const aarsAdapted: AARData[] = response.results.map(aar => this.aarDataAdapter.adaptTowDestination<EvStationDetailsResponse>(aar))

          return indexCollection<AARData, 'id'>(aarsAdapted, 'id')
        })
      )
  }
}
